// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"styles-module--iconWrapper--DLcKm"};